import { cn } from "@/lib/utils";
import { fmtDelta } from "@/lib/format";

/** Delta as plain coloured text with a typographic arrow – no chip background. `neutral` = informational (no red/green). */
export const Delta = ({ value, suffix = "", invert = false, neutral = false, className, ...props }) => {
  if (value === null || value === undefined) return null;
  const positive = invert ? value < 0 : value > 0;
  const flat = Math.abs(value) < 0.05;
  const arrow = flat ? "→" : value > 0 ? "↑" : "↓";
  const tone = neutral || flat ? "text-muted-foreground" : positive ? "text-emerald-600 dark:text-emerald-400" : "text-rose-600 dark:text-rose-400";
  return (
    <span className={cn("metric inline-flex items-center gap-0.5 whitespace-nowrap text-[12px] font-medium", tone, className)} {...props}>
      <span aria-hidden="true">{arrow}</span>
      {fmtDelta(value)}
      {suffix}
    </span>
  );
};
